export { ModalService } from 'sce-ui-lib/components/modal/modal.service';
// #TODO-LIBRARY



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/services/modal.service.ts